import script from "./ConformitySettingsDraftNumbering.vue?vue&type=script&setup=true&lang=js"
export * from "./ConformitySettingsDraftNumbering.vue?vue&type=script&setup=true&lang=js"

import "./ConformitySettingsDraftNumbering.vue?vue&type=style&index=0&id=26d2e5e4&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d2e5e4"]])

export default __exports__